import { Injectable, inject } from '@angular/core';
import { TslApiService } from 'projects/aztalena-core/src/public-api';
import { Observable } from 'rxjs';
import { Announcement } from './announcement';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {
  private api = inject(TslApiService);

  getAnnouncement(): Observable<Announcement | null> {
    return this.api.get('announcement');
  }
}
